import {
  CONNECT_BTN_CLICKED,
  DISCONNECT_BTN_CLICKED,
  ADD_EVENT_COLOR,
  HANDLE_MONTH_CHANGE,
  HANDLE_TIMEZONE_CHANGE,
  UPDATE_ISDEMOSSR,
  IS_DATES_RETURN,
  REFRESH_DATA,
  UPDATE_EVENTS_FOR_CALENDAR_SELECTED,
  UPDATE_CALENDAR_SELECTED,
  UPDATE_MONTH_EXISTS,
  IS_LOADED,
  ON_WIDGET_LOAD,
  GET_RECURRENCE_BY_RECURRENCEID,
} from './actionType';

import { generateTimeZoneDictionary } from '../utils/helpFunctions';
import {
  applicationLoadingStep,
  getStyleParams,
  setStartWeekOnNumberParam,
  setTimezoneNumberParam,
  wixEvents,
} from '../../../utils';
import {
  fetchApi,
  fetchApiWithRetry,
  fetchMultipleApis,
  getApiUrl,
  encodeColor,
  getTimezonesNames,
  getUnixMonth,
  getNextMonth,
  getPrevMonth,
  getBrowserTimezone,
} from './utils';
interface calendarColorMap {
  [calendarId: string]: string;
}

export const onSettingsUpdate = (update) => (dispatch) => {
  switch (update.key) {
    case 'connect':
      {
        dispatch(
          connectBtnClickedwidget(update.value.compId, update.value.userName),
        );
      }
      break;
    case 'disconnect':
      {
        dispatch(disconnect());
      }
      break;
    case 'addEventColor':
      {
        dispatch(
          addEventColor(
            update.value.dates,
            update.value.calendarsList,
            update.value.compId,
          ),
        );
      }

      break;
    case 'timezoneChanged':
      {
        dispatch(handleTimezoneChangeFromSettings(update.value.timezone));
      }

      break;
    case 'refreshData':
      dispatch(refreshData());
      break;
    default:
  }
};

export const updateIsDemoSSR = () => (dispatch) => {
  dispatch({
    type: UPDATE_ISDEMOSSR,
    payload: {
      isDemoSSR: false,
    },
  });
};

export const getEventsForCalendarSelected = (
  dates,
  currentCalendarIdSelected,
  calendarsExist,
) => (dispatch) => {
  const timezonesNames = getTimezonesNames();

  getStyleParams(async (styleParams: any) => {
    const timezone = styleParams.numbers.timeZone
      ? timezonesNames[styleParams.numbers.timeZone]
      : getBrowserTimezone();

    const apiUrl = getApiUrl('getEvents', {
      timezone,
      currentCalendarIdSelected: currentCalendarIdSelected.replace('#', '*'),
    });
    const res = await fetchApi(apiUrl);

    if (res) {
      const newObj = {};
      const arr = Object.keys(dates).concat(Object.keys(res.eventsByDates));

      const alldays = arr.filter((item, pos) => arr.indexOf(item) === pos);
      alldays.map((a, i) => {
        let arrForDate = [];
        if (dates[a]) {
          arrForDate = arrForDate.concat(dates[a]);
        }
        if (res.eventsByDates[a]) {
          arrForDate = arrForDate.concat(res.eventsByDates[a]);
        }
        if (arrForDate.length) {
          newObj[a] = arrForDate;
        }
      });

      if (calendarsExist !== undefined) {
        calendarsExist.push(currentCalendarIdSelected);
      }
      dispatch({
        type: UPDATE_EVENTS_FOR_CALENDAR_SELECTED,
        payload: {
          dates: newObj,
          calendarsExistArr: calendarsExist,
        },
      });
    }
  });
};

export const updateCalendarSelected = (calendarsList) => (dispatch) => {
  getStyleParams((styleParams: any) => {
    const calendarsExist: string[] = [];

    calendarsList &&
      calendarsList.map((c) => {
        const key = Object.keys(styleParams.booleans).find((k) =>
          k.includes(c.id),
        );
        if (key) {
          if (styleParams.booleans[key]) {
            calendarsExist.push(key);
          }
        } else if (c.selected) {
          calendarsExist.push(c.id);
        }
      });
    dispatch({
      type: UPDATE_CALENDAR_SELECTED,
      payload: {
        calendarsExistArr: calendarsExist,
      },
    });
  });
};

export const updateData = (calendarsList) => (dispatch) => {};

export const updateDefaultSiteColor = (dates, calendarsList) => (dispatch) => {
  const start = 18;
  let counter = 0;
  const myCalendarsColor = {};
  calendarsList &&
    calendarsList.map((item, i) => {
      counter = i % 4 === 0 ? 0 : counter;
      const colorEncode = encodeColor({
        name: `color_${start + counter * 5}`,
        opacity: 1,
      });

      const color = 'color';
      myCalendarsColor[`${item.idCrypt}`] = { value: colorEncode[color].value };
      counter++;
    });

  return myCalendarsColor;
};

export const onWidgetLoaded = () => async (dispatch: any) => {

  dispatch({
    type: IS_DATES_RETURN,
    payload: {
      isDatesReturn: false,
    },
  });
  applicationLoadingStep(10);

  const getCalendarsListUrl = getApiUrl('getCalendarsList', {});
  const getEventsUrl = getApiUrl('getEvents', {});
  const urlArray = [getCalendarsListUrl, getEventsUrl];

  try {
    const allResults = await fetchMultipleApis(urlArray);
    const isDemoContent = allResults[0].message === 'Unsubscribed user';

    const allCalendarsList = isDemoContent
      ? allResults[0].calendarsList.calendarsList
      : allResults[0].calendarsList;

    const events = allResults[1].eventsByDates;

    getStyleParams((styleParams: any) => {
      updateEventColor(events, allCalendarsList, styleParams);
    });

    dispatch({
      type: ON_WIDGET_LOAD,
      payload: {
        dates: events,
        calendarsList: allCalendarsList,
        isDemoContent,
      },
    });

    dispatch({
      type: IS_LOADED,
      payload: {
        isLoaded: true,
      },
    });

    applicationLoadingStep(20);
  } catch (err) {
    console.log(err);
  }
};

export const handleMonthChangeAction = (
  start: number,
  end: number,
  timezone: string,
  isNextClicked: boolean,
  dates: object,
  calendarsList,
  monthExistsArr,
  monthEventsExistsArr,

) => async (dispatch) => {
  const clickedCurrentTime = isNextClicked ? end : start;
  const monthExists: string[] = [];
  const monthEventsExists: string[] = [];
  const month = getUnixMonth(clickedCurrentTime);
  const monthNext = getNextMonth(clickedCurrentTime);
  const monthPrevious = getPrevMonth(clickedCurrentTime);

  if (typeof monthExistsArr === 'undefined') {
    monthExists.push(monthPrevious);
    monthExistsArr = monthExists;
  }

  if (typeof monthEventsExistsArr === 'undefined') {
    monthEventsExists.push(monthPrevious);
    monthEventsExists.push(month);
    monthEventsExists.push(monthNext);
    monthEventsExistsArr = monthEventsExists;
  }


  if (monthExistsArr && monthExistsArr.includes(month)) {
      console.log('The events already exists')
  } else {
  
    const apiUrl = getApiUrl('getEvents', {
  ...(timezone !== undefined && { timezone }),
      isNextClicked,
      clickedCurrentTime,

    });
    try {
      const res = await fetchApiWithRetry(apiUrl, 'eventsByDates');

      if (res) {
        if (typeof monthExistsArr === 'undefined') {
          monthExists.push(monthPrevious);
          monthExistsArr = monthExists;
        } else {
          monthExistsArr.push(monthPrevious);
        }

        monthEventsExists.push(monthPrevious);
        monthEventsExists.push(month);
        monthEventsExists.push(monthNext);

        const allEvents = { ...dates, ...res.eventsByDates };

        getStyleParams(async (styleParams: any) => {
          dispatch(updateEventColor(allEvents, calendarsList, styleParams));
          dispatch({
            type: HANDLE_MONTH_CHANGE,
            payload: {
              dates: allEvents,
              monthExistsArr,
              monthEventsExistsArr,
            },
          });
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
};

export const handleTimezoneChangeAciton = (
  dates: any,
  timezone: string,
  start: number,
) => async (dispatch) => {
  const apiUrl = getApiUrl('getEvents', {
    timezone,
    clickedCurrentTime: start,
  });
  try {
    const result = await fetchApi(apiUrl);
    const allEvents = { ...dates, ...result.eventsByDates };
    dispatch({
      type: HANDLE_TIMEZONE_CHANGE,
      payload: {
        dates: allEvents,
      },
    });
  } catch (err) {
    console.log(err);
  }
};

export const handleTimezoneChangeFromSettings = (timezone: string) => async (
  dispatch,
) => {
  const apiUrl = getApiUrl('getEvents', { timezone });
  try {
    const res = await fetchApi(apiUrl);
    dispatch({
      type: HANDLE_TIMEZONE_CHANGE,
      payload: {
        dates: res.eventsByDates,
      },
    });
  } catch (err) {
    console.log(err);
  }
};

export const addEventColor = (dates, calendarsList, compId) => (
  dispatch: any,
) => {
  addEventListener(
    wixEvents.STYLE_PARAMS_CHANGE,
    async (styleParams: Object) => {
      dispatch(updateEventColor(dates, calendarsList, styleParams));
      dispatch({
        type: ADD_EVENT_COLOR,
        payload: { dates },
      });
    },
  );
};

export const getCalendarColorForSiteColor = (
  calendarsList,
  myCalendarsColor,
  styleParams,
) => (dispatch) => {
  const calendarsColor: object[] = [];
  let calendarColor: calendarColorMap = {};
  calendarsList &&
    calendarsList.map((c) => {
      if (styleParams.colors.hasOwnProperty(c.idCrypt)) {
        calendarColor = {
          calendarId: c.idCrypt,
          value: styleParams.colors[c.idCrypt].value,
        };
      } else {
        calendarColor = {
          calendarId: c.idCrypt,
          value: myCalendarsColor[c.idCrypt].value,
        };
      }
      calendarsColor.push(calendarColor);
    });

  return calendarsColor;
};

export const updateEventColor = (events, calendarsList, styleParams) => (
  dispatch,
) => {
  const myCalendarsColor = dispatch(
    updateDefaultSiteColor(events, calendarsList),
  );

  const calendarColorForSiteColor = dispatch(
    getCalendarColorForSiteColor(calendarsList, myCalendarsColor, styleParams),
  );

  for (const event in events) {
    if (!events.hasOwnProperty(event)) {
      continue;
    }
    const obj = events[event];
    if (
      styleParams.numbers.siteOrGoogleCalendarColors &&
      styleParams.numbers.siteOrGoogleCalendarColors === 1
    ) {
      obj.map((o: any, i: number) => {
        o.eventColor = o.googleColor;
      });
    } else {
      obj.map((o, i) => {
        const matchingColorEntry = calendarColorForSiteColor.find(
          (x) => x.calendarId === o.calendarId
        );

        if (!matchingColorEntry) {
          return o.eventColor;
        }

        o.eventColor = matchingColorEntry.value;
      });
    }
  }
};

export const disconnect = () => async (dispatch: any) => {
  window.localStorage.removeItem('recurringKeys');

  dispatch({
    type: IS_DATES_RETURN,
    payload: {
      isDatesReturn: false,
    },
  });

  const urls = [getApiUrl('getCalendarsList', {}), getApiUrl('getEvents', {})];

  try {
    const allResults = await fetchMultipleApis(urls);
    if (allResults) {
      dispatch({
        type: DISCONNECT_BTN_CLICKED,
        payload: {
          isDatesReturn: true,
          isConnect: false,
          userName: '',
          calendarsList: allResults[0].calendarsList.calendarsList,
          dates: allResults[1].eventsByDates,
        },
      });
      dispatch({ type: IS_DATES_RETURN, payload: { isDatesReturn: true } });
    }
  } catch (error) {
    console.log(error);
  }
};

export const refreshData = () => async (dispatch) => {
  const urls = [getApiUrl('getCalendarsList', {}), getApiUrl('getEvents', {})];
  try {
    const allResults = await fetchMultipleApis(urls);
    if (allResults) {
      dispatch({
        type: REFRESH_DATA,
        payload: {
          calendarsList: allResults[0].calendarsList,
          dates: allResults[1].eventsByDates,
          isDatesReturn: true,
        },
      });
      dispatch({ type: IS_DATES_RETURN, payload: { isDatesReturn: true } });
    }
  } catch (error) {
    console.log(error);
  }
};
export const getRecurrence = (dates,calendarId:string, recurringEventId:string) => async (dispatch) => {
const apiUrl = getApiUrl('getRecurrence', {calendarId, recurringEventId  });
 try {
    const res = await fetchApi(apiUrl);

    if(recurringEventId && res && res.recurrence) {
        for (const key in dates) {
          const arr = dates[key];
          arr.map((event) => {
            if (event.recurringEventId === recurringEventId) {
              (event.recurrence = res.recurrence);
            }
          });
        }

      let recurrnceObj = {recurrenceId:recurringEventId,recurrence:res.recurrence}
      let setRecurrence = []
      //@ts-ignore
      setRecurrence.push(recurrnceObj)
      dispatch({
        type: GET_RECURRENCE_BY_RECURRENCEID,
        payload: {
          recurrences:setRecurrence,
          dates
        },
      });
   }
} catch (error) {
    console.log(error);
  }
};

export const connectBtnClickedwidget = (compId, userName: string) => async (
  dispatch: any,
) => {
  dispatch({
    type: IS_DATES_RETURN,
    payload: { isDatesReturn: false },
  });

  dispatch({
    type: IS_LOADED,
    payload: { isDatesReturn: false },
  });

  const getSettingsUrl = getApiUrl('getSettings', {}, compId);
  try {
    const res = await fetchApi(getSettingsUrl);

    const timezonesNames = getTimezonesNames();
    const timezoneValue = generateTimeZoneDictionary(timezonesNames);
    const googleSettingsTimezone = res.getSettings
      ? res.getSettings[9].value
      : getBrowserTimezone();

    setTimezoneNumberParam(timezoneValue[googleSettingsTimezone]);
    const startWeekOn = res.getSettings ? res.getSettings[3].value : 0;
    setStartWeekOnNumberParam(Number(startWeekOn));

    const getCalendarsListUrl = getApiUrl('getCalendarsList', {}, compId);
    const getEventsUrl = getApiUrl(
      'getEvents',
      { timezone: googleSettingsTimezone },
      compId,
    );
    const urlArray = [getCalendarsListUrl, getEventsUrl];

    try {
      const allResults = await fetchMultipleApis(urlArray);
      const calendarsSelected: string[] = [];
      allResults[0].calendarsList.map((c) => {
        if (c.selected) {
          calendarsSelected.push(c.id);
        }
      });
      if (allResults[0].calendarsList.status > 200 || allResults[1].error) {
        return dispatch({
          type: CONNECT_BTN_CLICKED,
          payload: {
            isConnect: true,
            userName,
            dates: {},
            recurrenceArr: [],
            calendarsList: [],
            googleSettings: {},
            isErrorApi: true,
            isDatesReturn: false,
          },
        });
      }
      const events = allResults[1].eventsByDates;

      getStyleParams((styleParams: any) => {
        dispatch(
          updateEventColor(events, allResults[0].calendarsList, styleParams),
        );
      });

      dispatch({
        type: CONNECT_BTN_CLICKED,
        payload: {
          isConnect: true,
          userName,
          dates: events,
          calendarsList: allResults[0].calendarsList,
          googleSettings: res.getSettings,
          isErrorApi: false,
          isDatesReturn: true,
          calendarsExistArr: calendarsSelected,
        },
      });
    } catch (error) {
      console.log(error);
    }
  } catch (error) {
    console.log(error);
  }
};
